import { useResizeObserver } from "./useResizeObserver";

export const useAppResize = () => {
    const size = useResizeObserver(document.body);
    return size;
};